import { api as $axios } from '@/helpers/interceptors'
import { GET_ITEC_LOGS, GET_GATEWAY_LOGS } from '@/constants/path'
import { meta } from '@/config/pagination'
import snakeCaseKeys from 'snakecase-keys'

const setUnLoading = (commit, status = false) => {
  commit('SET_STATE', {
    key: 'isLoading',
    value: status,
  })
}
const state = () => ({
  dataItec: [],
  isLoading: false,
  meta,
})

// getters
const getters = {}

// actions
const actions = {
  async getItecLogs({ commit }, params) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(
        `${GET_ITEC_LOGS}`,
        'get',
        snakeCaseKeys({ params }),
      )
      commit('SET_STATE', {
        key: 'dataItec',
        value: res?.data?.data,
      })
      commit('SET_STATE', {
        key: 'meta',
        value: res?.data?.meta,
      })
      setUnLoading(commit)
    } catch (error) {
      commit('SET_STATE', { key: 'dataItec', value: [] })
      commit('SET_STATE', {
        key: 'meta',
        value: meta,
      })
      setUnLoading(commit)
    }
  },
  async getGatewayLogs({ commit }, params) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(
        `${GET_GATEWAY_LOGS}`,
        'get',
        snakeCaseKeys({ params }),
      )
      commit('SET_STATE', {
        key: 'dataItec',
        value: res?.data?.data,
      })
      commit('SET_STATE', {
        key: 'meta',
        value: res?.data?.meta,
      })
      setUnLoading(commit)
    } catch (error) {
      commit('SET_STATE', { key: 'dataItec', value: [] })
      commit('SET_STATE', {
        key: 'meta',
        value: meta,
      })
      setUnLoading(commit)
    }
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
